<script>
  import { mapTypeHandleToComponent } from '/componentMappings'
  import { _ } from 'svelte-i18n'

  import CardNews from '/components/Widgets/CardNews'
  import CardAlmanac from '/components/Widgets/CardAlmanac'
  import CardMoon from '/components/Widgets/CardMoon'
  import CardHeadline from '/Widgets/CardHeadline'
  import CardProjectEvent from '/Widgets/CardProjectEvent'
  import CardLivestream from '/Widgets/CardLivestream'
  import CardWeather from '/Widgets/CardWeather'
  import LittleCards from '/Widgets/LittleCards'
  import CardFeaturedNews from '/Widgets/CardFeaturedNews'
  import CardExhibition from '/Widgets/CardExhibition'

  import CardsGroupHome from '/components/Groups/CardsGroupHome'

  export let data

  let real100vh = 0;
  let minReal100vh = 0;

  $: {
    if (real100vh < minReal100vh || minReal100vh == 0 && real100vh != 0) {
      minReal100vh = real100vh
    }
  }

  const news = data?.News?.filter( e => e.typeHandle === "text" && !e.tags?.find(t => t.slug === "featured")) || []
  const featuredNews = data?.News?.filter( e => e.typeHandle === "text" && e.tags?.find(t => t.slug === "featured")) || []

  let cards = []

  if (data) {
    cards = [
      /*  
      // livestream
      {
        column: "right",
        component: CardLivestream,
        props: {
        }
      },
      */
      // Featured News
      ...featuredNews.map( item => ({
        component: CardFeaturedNews,
        column: "left",
        props: {
          item
        }
      })),
      // Almanac
      {
        column: "right",
        component: CardAlmanac,
        props: {
          entries: data.Almanac,
          showmore: true
        }
      },
      // Featured
      ...([data?.Featured] || []).map( entry => ({
        column: "right",
        featured: true,
        ...mapTypeHandleToComponent(entry)
        })
      ),
      // Moon
      {
        component: CardMoon,
        column: "right",
      },
      // Ongoing Programme / WhatsOn
      ...data.WhatsOn.map( entry => ({
        component: CardExhibition,
        props: {
          date: $_('home.ongoing_programme'),
          event: entry,
          title: entry.teaser,
          subtitle: entry.title,
          image: entry?.backgroundImage?.[0]?.url,
          link: { slug: entry.slug, section: entry.typeHandle+"s"},
          ongoing: true,
        }
      })),
      // Year Long Festival
      {
        component: CardHeadline,
        content: $_('home.year_long_festival'),
        props: {
          bgColorKey: "purewhite",
          info: true,
          link: {to: "/theme"}
        }
      },
      // Passes
      {
        component: $_('home.passes.url') != "home.passes.url" ? CardHeadline : null,
        content: $_('home.passes.title'),
        props: {
          bgColorKey: "purewhite",
          info: false,
          nohole: true,
          link: {to: $_('home.passes.url')}
        }
      },
      {
        component: CardWeather
      },
      {
        component: LittleCards
      },
      // News
      {
        component: CardNews,
        props: {
          entries: news
        }
      },
    ]
  }

/*
  const cards = [
    {
      component: ContentBox,
      content: "right 1",
      column: "right"
    }, 
    {
      component: ContentBox,
      content: "left 1",
      column: "left"
    },     
    {
      component: ContentBox,
      content: "right 2",
      column: "right"
    }, 
    {
      component: ContentBox,
      content: "left 2",
      column: "left"
    },
    {
      component: CardHeadline,
      column: "left",
      content: "Ongoing Programme",
    },     
    {
      component: CardExhibition,
      column: "left",
      props: {
        title: "For Refulas Exhibition" ,
        date: "24.01.–13.03.2021" ,
        image: "https://placeimg.com/640/480/arch/sepia",
      }
    },
    {
      component: CardVideo,
      column: "right",
      props: {
        title:"The Reclamation of Social Time" ,
        subtitle: "Donna Haraway" ,
        image: "https://placeimg.com/640/480/people",
      }
    },
  ]
*/

</script>

<svelte:window bind:innerHeight={real100vh} />


<section style={`--real100vh: ${minReal100vh}px;`}>
  
  <CardsGroupHome {cards} />

</section>

<style lang="scss">
  section {
    margin-top: calc( 100vh - #{$frame-top-large + 70px});
    margin-top: calc( var(--real100vh) - #{$frame-top-large + 70px} ); /* ios mobile, see also https://caniuse.com/intrinsic-width */
    @include media-small {
      margin-top: calc( 100vh - #{$frame-top-small + 50px});
      margin-top: calc( var(--real100vh) - #{$frame-top-small + 50px} );  /* ios mobile, see also https://caniuse.com/intrinsic-width */
    }
    transition: margin-top 1s;
  }

</style>